module.exports = __webpack_public_path__ + "static/media/scroll-down.505b484c.svg";